























import { Component, Vue, Prop } from 'vue-property-decorator';
import DepartmentShow from '@/components/Department/DepartmentShow.vue';
import { GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';

@Component({
  components: {
    DepartmentShow,
  },
})
export default class DepartmentShowButton extends Vue {
  @Prop() public department!: GQL_currentUnitDepartments_currentUnit_departments;
  public showDialog = false;
}
